module.exports = __webpack_public_path__ + "img/P7.71d4c4e4.png";